import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { FAMILLE_SEARCH_RESET } from "../constantes/famillesConstantes";
import ListeFamille from "./ListeFamille";
import { famillesSearch } from "../actions/famillesActions";
import { listeArticlesPromo } from "../actions/articlesActions";
import "../ListeFamilleMain.css";

const ListeFamilleMain = () => {
  const [search, setSearch] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { langue, wcli } = location.state || {};

  const fSearch = useSelector((state) => state.familleSearchListe);
  const { familles, loading } = fSearch;
  const Cl = useSelector((state) => state.client);
  const { client } = Cl;
  const larticles = useSelector((state) => state.articleListePromo);
  const { articles } = larticles;

  useEffect(() => {
    document.title =
      langue === "F" ? "Liste des familles" : "قائمـــة العائلات";

    if (!client) {
      navigate("/");
    }
    dispatch(listeArticlesPromo());
    updateSearch(search);
  }, [client, search]);

  const renderItem = (famille) => (
    <div className="famille-item-container">
      <ListeFamille
        libelle={famille.lib_fam}
        libelle_ar={famille?.lib_ar_fam}
        image={famille.image}
        id={famille._id}
        langue={langue}
        wcli={wcli}
        nav="articlesParFamille"
      />
    </div>
  );

  const updateSearch = (search) => {
    setSearch(search);
    dispatch(famillesSearch(search));
  };

  const existPromo = () => {
    return articles?.some((a) => a?.promo === "O");
  };

  return (
    <div className="famille-main-container">
      <div className="search-container">
        <input
          type="text"
          placeholder={langue === "F" ? "Chercher marque" : "بحث عن ماركة"}
          value={search}
          onChange={(e) => updateSearch(e.target.value)}
          className="search-input"
        />
      </div>

      {loading ? (
        <div className="loading-container">
          <div className="spinner"></div>
        </div>
      ) : (
        <div className="famille-grid">
          {familles?.map((famille) => renderItem(famille))}
        </div>
      )}
    </div>
  );
};

export default ListeFamilleMain;
